var render = function render(_c,_vm){return _c('div',{staticClass:"d-flex flex-column align-items-center justify-content-center h-100"},[_c('Icon',{staticClass:"empty-icon",attrs:{"icon":"stack"}}),_c('div',{staticClass:"mt-4 text-muted"},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.props.label || 'Empty')+" ")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }